import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { openModal } from '../../../redux/modal';
import { textStyles, colorPalette } from '../../../styles/styleGuide';
import { HOCObserveSize } from '../utils/HOCObserveSize';
import ImageLoader from '../ui/ImageLoader';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClick: function onClick(src) {
      dispatch(openModal('#fff', {
        type: 'image',
        componentProps: {
          image: src
        }
      }));
    }
  };
};
var ImageCentered = /*#__PURE__*/function (_Component) {
  function ImageCentered() {
    var _this;
    _classCallCheck(this, ImageCentered);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ImageCentered, [].concat(args));
    _defineProperty(_this, "handleClick", function (src) {
      _this.props.onClick(src);
    });
    return _this;
  }
  _inherits(ImageCentered, _Component);
  return _createClass(ImageCentered, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        mediaId = _this$props.mediaId,
        media = _this$props.media,
        renderWidth = _this$props.renderWidth,
        alt = _this$props.alt,
        caption = _this$props.caption;
      var src = mediaId && media ? media[mediaId] : '';
      return __jsx(ImageWrapper, {
        "data-id": "richText_ImageCentered_ImageWrapper"
      }, __jsx(LoadContainer, {
        "data-id": "richText_ImageCentered_LoadContainer"
      }, __jsx(ImageLoader, {
        width: renderWidth,
        src: src,
        alt: alt,
        mode: "img",
        onClick: function onClick() {
          return _this2.handleClick(src);
        },
        "data-id": "richText_ImageCentered_ImageLoader"
      })), caption && __jsx(Caption, {
        "data-id": "richText_ImageCentered_Caption"
      }, caption));
    }
  }]);
}(Component);
export default connect(null, mapDispatchToProps)(HOCObserveSize(ImageCentered));
var ImageWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 30rem;\n"])));
var LoadContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n  box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.16);\n\n  > div {\n    cursor: pointer;\n  }\n"])));
var Caption = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  color: ", ";\n  ", " display: inline-block;\n  box-sizing: border-box;\n"])), colorPalette.textGrey, textStyles.caption);